module.exports = __webpack_public_path__ + "static/img/event17.f4ede06.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event17.png
// module id = iKjB
// module chunks = 1